export default __webpack_public_path__ + "static/media/profile-img.afb7323f.jpg";